export default __webpack_public_path__ + "static/media/RIDE2.67da5465.jpg";